import { Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { doc, Firestore, getDoc } from '@angular/fire/firestore';

@Injectable({ providedIn: 'root' })
export class DebugModeService {
    private _isDebugUser = false;

    get isDebugUser(): boolean {
        return this._isDebugUser;
    }

    constructor(
        private auth: Auth,
        private firestore: Firestore,
    ) {}

    async checkDebugStatus(): Promise<boolean> {
        const userId = this.auth.currentUser?.uid;
        if (!userId) return false;
        try {
            const debugDoc = await getDoc(
                doc(this.firestore, `config/debugMode/debugUsers/${userId}`)
            );
            this._isDebugUser = debugDoc.exists();
            return this._isDebugUser;
        } catch (error) {
            console.error('[DebugModeService] Failed to check debug status:', error);
            this._isDebugUser = false;
            return false;
        }
    }

    reset(): void {
        this._isDebugUser = false;
    }
}
